export default __webpack_public_path__ + "static/media/resend-icon.42141ddd.svg";